module.exports = __webpack_public_path__ + "img/icon2.0667374a.png";